import { CheckboxBlock } from './CheckboxBlock'
import { SelectBase } from './SelectBase'
import { Select2Brand } from './Select2Brand'
import { Select2Importer } from './Select2Importer'
import { Select2ServiceCenter } from './Select2ServiceCenter'
import { router } from '~/router'
import { useReports } from './useReports'
import { createReport, getExcel } from '~/api/reports'
import store from '~/store'
import { range } from 'ramda'
import * as toast from '~/ToastGenerator'

/** @enum */
const Month = {
	1: 'Январь',
	2: 'Февраль',
	3: 'Март',
	4: 'Апрель',
	5: 'Май',
	6: 'Июнь',
	7: 'Июль',
	8: 'Август',
	9: 'Сентябрь',
	10: 'Октябрь',
	11: 'Ноябрь',
	12: 'Декабрь',
}

/** @enum */
const Subject = {
	Manufacturer: 'manufacturer',
	Importer: 'importer',
	Service: 'service',
}

const SubjectName = {
	[Subject.Manufacturer]: 'Производитель',
	[Subject.Importer]: 'Импортёр',
	[Subject.Service]: 'Сервис',
}

const Quarter = ['Q1', 'Q2', 'Q3', 'Q4']

const Status = ['Ожидание', 'Подтверждён', 'Отклонён']

const FormReports = {
	router,
	data: (vm) => ({
		subject: vm.$router.history.current.query.id,
		subjectType: vm.$router.history.current.query.subject || Subject.Manufacturer,
		quarter: vm.$router.history.current.query.quarter,
		month: vm.$router.history.current.query.month,
		year: vm.$router.history.current.query.year,
		status: vm.$router.history.current.query.status,
	}),
	computed: {
		years: () => {
			const yearMin = Number.parseInt(store.min, 10)
			const yearMax = Number.parseInt(store.max, 10)

			return range(yearMin, yearMax + 1)
		},
	},
	methods: {
		reset() {
			this.$router.push(`${location.pathname}`)
				.then(() => useReports().mutate())
		},
		create() {
			if (!this.$el.reportValidity()) return

			createReport(new FormData(this.$el))
				.then((response) => {
					if (!response.status) throw Error(response.error)

					toast.success({
						heading: 'Успешно',
						text: 'Отчет создан',
						autohide: true,
						delay: 2500,
					})

					return response
				})
				.then(() => useReports().mutate())
				.catch((error) => toast.error({
					heading: 'Ошибка',
					text: error.message,
					autohide: true,
					delay: 5000,
				}))
		},
		search() {
			this.$router
				.push(`${location.pathname}/?${new URLSearchParams(new FormData(this.$el)).toString()}`)
				.then(() => useReports().mutate())
		},
		getExcel() {
			getExcel(this.$router.history.current.query)
		},
	},
	mounted() {
		this.$router.afterEach((to, from) => {
			this.subject = to.query.id
			this.subjectType = to.query.subject || Subject.Manufacturer
			this.quarter = to.query.quarter
			this.month = to.query.month
			this.year = to.query.year
			this.status = to.query.status
		})
	},
	render(h) {
		return (
			<form
				class="form-service form-service-reports"
				vOn:submit_prevent={this.search}
			>
				<SelectBase
					name="year"
					vOn:change={(event) => this.year = event.currentTarget.value}
					required
				>
					<option value="">Год</option>
					{this.years.map(value => (
						<option
							value={value}
							selected={this.year === value}
						>
							{value}
						</option>
					))}
				</SelectBase>

				<SelectBase
					name="month"
					vOn:change={(event) => this.month = event.currentTarget.value}
					disabled={!!this.quarter}
				>
					<option value="">Месяц</option>
					{Object.entries(Month).map(([month, monthName]) => (
						<option
							value={month}
							selected={this.month === month}
						>
							{monthName}
						</option>
					))}
				</SelectBase>

				<SelectBase
					name="quarter"
					vOn:change={(event) => this.quarter = event.currentTarget.value}
					disabled={!!this.month}
				>
					<option value="">Квартал</option>
					{Quarter.map((quarter) => (
						<option
							value={quarter}
							selected={this.quarter === quarter}
						>
							{quarter}
						</option>
					))}
				</SelectBase>

				<SelectBase
					name="subject"
					vOn:change={(event) => this.subjectType = event.currentTarget.value}
				>
					{Object.values(Subject).map((subject) => (
						<option
							value={subject}
							selected={this.subjectType === subject}
						>
							{SubjectName[subject]}
						</option>
					))}
				</SelectBase>

				{this.subjectType === Subject.Manufacturer ? (
					<Select2Brand
						value={this.subject}
						name="id"
						vOn:select={(option) => this.subject = option.id}
						required
					/>
				) : null}

				{this.subjectType === Subject.Importer ? (
					<Select2Importer
						value={this.subject}
						vOn:select={(option) => this.subject = option.id}
						name="id"
						required
					/>
				) : null}


				{this.subjectType === Subject.Service ? (
					<Select2ServiceCenter
						value={this.subject}
						vOn:select={(option) => this.subject = option.id}
						name="id"
						required
					/>
				) : null}

				<div class="col-span-full flex">
					{Status.map((status) => (
						<CheckboxBlock
							label={status}
							name="status"
							value={status}
							checked={this.status instanceof Array ? this.status.includes(status) : this.status === status}
						/>
					))}
				</div>

				<div class="col-span-3">
					<button class="button button_theme_secondary mr-5" type="submit">
						Найти
					</button>
					<button
						class="button button_theme_secondary-ghost"
						type="button"
						onClick={this.reset}
					>
						Сбросить
					</button>
				</div>
				<div class="col-span-2 text-right">
					<button
						class="button button_theme_secondary-ghost"
						type="button"
						onClick={this.getExcel}
					>
						Excel
					</button>
					<button
						class="button button_theme_secondary-ghost ml-5"
						type="button"
						onClick={this.create}
					>
						Создать отчет
					</button>
				</div>
			</form>
		)
	}
}

export default FormReports
